import JsBarcode from 'jsbarcode';

// JsBarcode draws into a live SVG element, so make one off-document, let it draw,
// and take the markup. Serialising beats re-implementing Code128 — and a string
// can be written straight into a print document, where a React effect could not
// run in time.
export function barcodeSvg(value, { format = 'CODE128', height = 40, width = 1.4, fontSize = 11, displayValue = true, margin = 2 } = {}) {
  if (!value) return '';
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  try {
    JsBarcode(svg, String(value), { format, height, width, fontSize, margin, displayValue });
  } catch (e) { return ''; }
  return new XMLSerializer().serializeToString(svg);
}

export default barcodeSvg;
